import { APIPath } from 'utility/constant'
import { CRUDService } from './crud'
import { BaseService } from './base'
import { CommonUtility } from 'utility/common'

class Viewers extends CRUDService {
    constructor() {
        super(APIPath.viewers) // Initialize CRUDService with Viewerss API path
    }

    getBlockedViewers(params) {
        const url = `${APIPath.users}/block-viewers?${CommonUtility.objectToParams(params)}`
        return BaseService.get(url, this.isSecure)
    }
}

// Initialize the service with the desired API path
const ViewersService = new Viewers(APIPath.viewers)
Object.freeze(ViewersService)

export { ViewersService }
